import { DomeComponent, React } from "@lexriver/dome"
import { Settings } from "../../Settings"
import { EnumCurrency } from "../enums/EnumCurrency"

interface Attrs{
    price?:number
    priceInDollar?:number
    hideEqualSignBeforeDollar?:boolean
}

export class Price extends DomeComponent<Attrs>{
    render() {
        if(Settings.checkIfDomainIsShop() && this.attrs.priceInDollar){
            // {/* {this.attrs.hideEqualSign ? '' : <>&nbsp;≈&nbsp;</>} */}
            return Settings.formatNumberToPrice(this.attrs.priceInDollar, EnumCurrency.USD)
        }
        if(this.attrs.price){
            return Settings.formatNumberToPrice(this.attrs.price, EnumCurrency.RUB)
        }
        return <></>
    }
}